import DOMPurify from 'dompurify'
import { memo } from 'react'

interface SafeHtmlProps {
  html: string
  className?: string
}

export const SafeHtml = memo(function SafeHtml({
  html,
  className
}: SafeHtmlProps) {
  const sanitizedHtml = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ALLOWED_TAGS: [
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'p',
      'a',
      'ul',
      'ol',
      'li',
      'br',
      'strong',
      'em',
      'code',
      'pre',
      'blockquote',
      'table',
      'thead',
      'tbody',
      'tr',
      'th',
      'td'
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
  })

  return (
    <div
      className={className}
      data-testid="safe-html-container"
      // biome-ignore lint/security/noDangerouslySetInnerHtml: Sanitized
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  )
})
